import React, { useEffect } from "react";
import * as echarts from "echarts";
import { Font } from "@react-pdf/renderer";

export const ChartVentasNEtas = ({ name, data }) => {
  useEffect(() => {
    const dom = document.getElementById(name);
    const myChart = echarts.init(dom, null, {
      renderer: "canvas",
      useDirtyRect: false,
    });
    const shortMonths = [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ];
    const fullMonths = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];

    // const currentMonth = new Date().getMonth() + 1; // Obtener el mes actual (1-12)
    const currentMonth = data.ventasnetas.length;
    const formatmiles = (number) => {
      return Math.floor((number ?? 0) / 1000);
    };

    const formatmiles2 = (number) => {
      return number.toLocaleString("en-US");
    };

    const ejercicioActualData = data?.ventasnetas
      ? data.ventasnetas.map((item) => formatmiles(item.ventaneta))
      : [];
    const ejercicioAnteriorData = data?.ventasnetasAnterior
      ? data.ventasnetasAnterior.map((item) =>
          formatmiles(item.ventanetaejercicioanterior)
        )
      : [];
    const proyeccionData = data?.ventasnetasproyectada
      ? data.ventasnetasproyectada.map((item) =>
          formatmiles(item.ventanetaproyectada)
        )
      : [];

    const añoActual = new Date().getFullYear();
    const añoAnterior = añoActual - 1;

    const maxDataValue = Math.max(
      ...ejercicioActualData,
      ...ejercicioAnteriorData,
      ...proyeccionData
    );

    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        formatter: function (params) {
          let tooltipText = params[0].name;
          fullMonths.forEach((month, index) => {
            if (shortMonths[index] === params[0].name) {
              tooltipText = month;
            }
          });
          return `
            <div>${tooltipText}</div>
            ${params
              .map(
                (param) => `
              <div>${param.seriesName}: $${formatmiles2(param.value)}</div>
            `
              )
              .join("")}
          `;
        },
      },
      legend: {
        top: "5%",
        data: [`${añoActual}`, `${añoAnterior}`, "Proyección"],
        textStyle: {
          fontSize: 14,
        },
      },
      grid: {
        left: "5%",
        right: "4%",
        bottom: "20%",
        top: "20%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          data: shortMonths.slice(0, currentMonth),
          axisPointer: {
            type: "shadow",
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          min: 0,
          max: Math.ceil(maxDataValue * 1.1), // Establecer el máximo un poco más alto para espacio adicional
          interval: Math.ceil(maxDataValue / 5), // Establecer intervalo basado en el máximo
          axisLabel: {
            formatter: "{value}",
          },
        },
        {
          type: "value",
          // name: "Proyección",
          min: 0,
          max: Math.ceil(maxDataValue * 1.1), // Establecer el máximo un poco más alto para espacio adicional
          interval: Math.ceil(maxDataValue / 5), // Establecer intervalo basado en el máximo
          axisLabel: {
            formatter: "{value}",
          },
        },
      ],
      series: [
        {
          name: `${añoActual}`,
          type: "bar",
          data: ejercicioActualData,
          itemStyle: {
            color: "#035917",
          },
        },
        {
          name: `${añoAnterior}`,
          type: "bar",
          data: ejercicioAnteriorData,
          itemStyle: {
            color: "#dae6be",
          },
        },
        {
          name: "Proyección",
          type: "line",
          yAxisIndex: 1,
          data: proyeccionData,
          itemStyle: {
            color: "#ffc107",
          },
        },
      ],
    };

    myChart.setOption(option);

    window.addEventListener("resize", () => {
      myChart.resize();
    });

    return () => {
      window.removeEventListener("resize", () => {
        myChart.resize();
      });
      myChart.dispose();
    };
  }, [data]);

  return <div id={name} style={{ width: "399px", height: "290px" }}></div>;
};
